var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "coupon-list-container" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-remove": _vm.removeTab },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: "红包类型管理",
                name: "couponList",
                closable: false,
              },
            },
            [
              _c(
                "div",
                { staticClass: "filter-container" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "search-form",
                      attrs: { inline: true, model: _vm.searchForm },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "券名称" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入券名称",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.couponName,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "couponName", $$v)
                              },
                              expression: "searchForm.couponName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择类型",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.couponType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "couponType", $$v)
                                },
                                expression: "searchForm.couponType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: "" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "满减券", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "折扣券", value: 2 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "品项券", value: 3 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "赠品券", value: 4 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "免邮券", value: 5 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch },
                            },
                            [_vm._v("搜索")]
                          ),
                          _vm._v(" "),
                          _c("el-button", { on: { click: _vm.resetSearch } }, [
                            _vm._v("重置"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "action-buttons" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.handleBatchSyncTcCoupon },
                    },
                    [_vm._v("批量同步天财券")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "typeId",
                      label: "ID",
                      align: "center",
                      "min-width": "80",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "typeName",
                      label: "名称",
                      align: "center",
                      "min-width": "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.typeName))]),
                            _vm._v(" "),
                            scope.row.thirdCouponId
                              ? _c("div", [
                                  _vm._v(
                                    "[" + _vm._s(scope.row.thirdCouponId) + "]"
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "typeGroup",
                      label: "红包类型",
                      align: "center",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getCouponTypeText(scope.row.typeGroup)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "imgUrl",
                      label: "图片",
                      align: "center",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.imgUrl
                              ? _c(
                                  "div",
                                  { staticClass: "image-container" },
                                  [
                                    _c("el-image", {
                                      staticClass: "coupon-image",
                                      attrs: {
                                        src: _vm.getImageUrl(scope.row.imgUrl),
                                        fit: "cover",
                                        "preview-src-list": [
                                          _vm.getImageUrl(scope.row.imgUrl),
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "image-upload-overlay" },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "image-upload-inline",
                                            attrs: {
                                              action: "#",
                                              "show-file-list": false,
                                              "http-request": function (
                                                options
                                              ) {
                                                return _vm.handleImageUpload(
                                                  options,
                                                  scope.row
                                                )
                                              },
                                              "before-upload":
                                                _vm.beforeImageUpload,
                                              name: "file",
                                            },
                                          },
                                          [
                                            _c("el-button", {
                                              attrs: {
                                                size: "mini",
                                                type: "primary",
                                                icon: "el-icon-edit",
                                                circle: "",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("el-button", {
                                          attrs: {
                                            size: "mini",
                                            type: "danger",
                                            icon: "el-icon-delete",
                                            circle: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleClearImage(
                                                scope.row
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "el-upload",
                                  {
                                    staticClass: "upload-demo",
                                    attrs: {
                                      action: "#",
                                      "show-file-list": false,
                                      "http-request": function (options) {
                                        return _vm.handleImageUpload(
                                          options,
                                          scope.row
                                        )
                                      },
                                      "before-upload": _vm.beforeImageUpload,
                                      name: "file",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                      },
                                      [_vm._v("点击上传")]
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "typeMoney",
                      label: "券金额",
                      align: "center",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatAmount(scope.row.typeMoney)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "minGoodsAmount",
                      label: "最低消费金额",
                      align: "center",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatAmount(scope.row.minGoodsAmount)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "grossNum",
                      label: "发放数量",
                      align: "center",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "surplus",
                      label: "剩余数量",
                      align: "center",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "canShare",
                      label: "是否分享",
                      align: "center",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    scope.row.canShare === 1
                                      ? "success"
                                      : "info",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.canShare === 1 ? "是" : "否"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      align: "center",
                      "min-width": "300",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openIssueDialog(scope.row)
                                  },
                                },
                              },
                              [_vm._v("发放")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleView(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "warning" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSyncTcCoupon(scope.row)
                                  },
                                },
                              },
                              [_vm._v("同步")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-container" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: "券发放列表",
                name: "couponLogList",
                closable: false,
              },
            },
            [
              _c(
                "div",
                { staticClass: "filter-container" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "search-form",
                      attrs: { inline: true, model: _vm.couponLogSearchForm },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "券编号" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入券编号",
                              clearable: "",
                            },
                            model: {
                              value: _vm.couponLogSearchForm.couponNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.couponLogSearchForm,
                                  "couponNo",
                                  $$v
                                )
                              },
                              expression: "couponLogSearchForm.couponNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "券ID" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入券ID", clearable: "" },
                            model: {
                              value: _vm.couponLogSearchForm.couponId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.couponLogSearchForm,
                                  "couponId",
                                  $$v
                                )
                              },
                              expression: "couponLogSearchForm.couponId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员卡号" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入会员卡号",
                              clearable: "",
                            },
                            model: {
                              value: _vm.couponLogSearchForm.userCard,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.couponLogSearchForm,
                                  "userCard",
                                  $$v
                                )
                              },
                              expression: "couponLogSearchForm.userCard",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择状态",
                                clearable: "",
                              },
                              model: {
                                value: _vm.couponLogSearchForm.status,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.couponLogSearchForm,
                                    "status",
                                    $$v
                                  )
                                },
                                expression: "couponLogSearchForm.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: "" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "发送中", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "异常", value: 2 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "成功", value: 3 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleCouponLogSearch },
                            },
                            [_vm._v("搜索")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            { on: { click: _vm.resetCouponLogSearch } },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.couponLogLoading,
                      expression: "couponLogLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.couponLogTableData, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "couponId",
                      label: "券id",
                      align: "center",
                      "min-width": "200",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "couponNo",
                      label: "券编号",
                      align: "center",
                      "min-width": "200",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userId",
                      label: "会员ID",
                      align: "center",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cardNo",
                      label: "会员卡号",
                      align: "center",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status",
                      label: "状态",
                      align: "center",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getCouponLogStatusType(
                                    scope.row.status
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getCouponLogStatusText(
                                        scope.row.status
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createDate",
                      label: "发放时间",
                      align: "center",
                      "min-width": "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatDate(scope.row.createDate)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-container" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.couponLogCurrentPage,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.couponLogPageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.couponLogTotal,
                    },
                    on: {
                      "size-change": _vm.handleCouponLogSizeChange,
                      "current-change": _vm.handleCouponLogCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.detailTabs, function (item) {
            return _c(
              "el-tab-pane",
              {
                key: item.name,
                attrs: { label: item.title, name: item.name, closable: true },
              },
              [
                _c("coupon-detail", {
                  attrs: { "coupon-data": item.couponData },
                  on: {
                    "go-back": function ($event) {
                      return _vm.removeTab(item.name)
                    },
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "issue-dialog",
          attrs: {
            title: "发放红包",
            visible: _vm.issueDialogVisible,
            width: "900px",
            "before-close": function () {
              _vm.issueDialogVisible = false
            },
          },
          on: {
            "update:visible": function ($event) {
              _vm.issueDialogVisible = $event
            },
          },
        },
        [
          _vm.selectedCoupon
            ? _c(
                "el-form",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { "label-width": "100px" },
                },
                [
                  _c("el-form-item", { attrs: { label: "券名称：" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.selectedCoupon.typeName))]),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "券编号：" } }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.selectedCoupon.thirdCouponId)),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filter-container",
              staticStyle: { "margin-bottom": "20px" },
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: { inline: true, model: _vm.memberSearchForm },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入手机号", clearable: "" },
                        model: {
                          value: _vm.memberSearchForm.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.memberSearchForm, "mobile", $$v)
                          },
                          expression: "memberSearchForm.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleMemberSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-transfer", {
            staticClass: "transfer-container",
            attrs: {
              data: _vm.memberList,
              titles: ["未选择会员", "已选择会员"],
              "button-texts": ["移除", "添加"],
              filterable: "",
              "filter-placeholder": "请输入会员姓名或手机号",
            },
            on: { change: _vm.handleTransferChange },
            model: {
              value: _vm.selectedMemberIds,
              callback: function ($$v) {
                _vm.selectedMemberIds = $$v
              },
              expression: "selectedMemberIds",
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.issueDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleIssueCoupon },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }